import { Tool } from '@drodil/backstage-plugin-toolbox';
import { IamPolicyToolboxTool } from './IamPolicyToolboxTool';
import { IamPolicyRepairTool } from './IamPolicyRepairTool';
import { MermaidPreviewTool } from './MermaidPreviewTool';

export const extraToolboxTools: Tool[] = [
  {
    id: 'iam-policy-to-terraform',
    name: 'IAM policy ↔ Terraform',
    description:
      'Convert an AWS IAM policy JSON to the aws_iam_policy_document statements format (and back)',
    category: 'Convert',
    aliases: ['iam', 'terraform', 'policy', 'aws'],
    component: <IamPolicyToolboxTool />,
  },
  {
    id: 'iam-policy-repair',
    name: 'IAM / Terraform repair',
    description:
      'Parse and repair a broken IAM policy or Terraform statements file (syntax + structure), with a report of applied fixes',
    category: 'Convert',
    aliases: ['iam', 'terraform', 'policy', 'aws', 'repair', 'fix', 'json'],
    component: <IamPolicyRepairTool />,
  },
  {
    id: 'mermaid-preview',
    name: 'Mermaid preview',
    description: 'Render Mermaid diagram code and preview it live',
    category: 'Miscellaneous',
    aliases: ['mermaid', 'diagram', 'graph', 'flowchart'],
    component: <MermaidPreviewTool />,
  },
];
